<template>
  <div class="my-2 border p-2">
    <h5 class="mb-2">
      Age Segments
    </h5>
    <div>
      <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        @submit.prevent="repeatAgain"
      >

        <!-- Row Loop -->
        <b-form-row
          v-for="(segment, index) in tempAgeSegments"
          :key="segment.id"
          ref="row"
        >

          <!-- From Age -->
          <b-col md="3">
            <text-input
              id="from-age"
              v-b-tooltip.hover
              title="From age should be less than to age"
              :rules="{required:true,min_value:1,max_value:segment.to?segment.to-1:99}"
              name="From Age"
              :text.sync="segment.from"
            />
          </b-col>

          <!-- To Age -->
          <b-col md="3">
            <text-input
              id="to-age"
              v-b-tooltip.hover
              title="To age should be greater than from age"
              rules="required|min_value:1"
              name="To Age"
              :text.sync="segment.to"
            />
          </b-col>

          <!-- Capacity -->
          <b-col md="3">
            <text-input
              id="capacity"
              name="Capacity"
              type="number"
              rules="required|min_value:1"
              :text.sync="segment.capacity"
            />
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="2"
            md="3"
            class="mb-50"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>Delete</span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-form-row>
      </b-form>
      <div class="text-danger my-1">
        {{ capacityValid? '':`Segments capacity shouldn't be more than ${capacity}` }}
      </div>
    </div>
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      :disabled="!capacity"
      variant="primary"
      @click="repeatAgain"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-25"
      />
      <span>Add New</span>
    </b-button>
  </div>
</template>

<script>
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import TextInput from '../../common/FormInputs/TextInput.vue'

export default {
  name: 'AgeSegments',
  components: { TextInput },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    ageSegments: { type: Array, default: () => [] },
    capacity: { type: [Number, String], default: null },
  },
  data() {
    return {
      nextTodoId: 2,
    }
  },
  computed: {
    tempAgeSegments: {
      get() {
        return this.ageSegments
      },
      set(value) {
        this.$emit('update:ageSegments', value)
      },
    },
    capacityValid() {
      const totalCapacity = this.ageSegments.reduce((acc, curr) => acc + curr.capacity * 1, 0)
      const valid = this.capacity >= totalCapacity
      this.$emit('update:segmentsCapacityValid', valid)
      return valid
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeatAgain() {
      this.tempAgeSegments.push({
        id: this.nextTodoId += this.nextTodoId,
        capacity: null,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.tempAgeSegments.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
